module.exports = __webpack_public_path__ + "media/img/home/animate/screen3-5eb2d6481b3b255d64ff3d0984e122ee.svg";